// extracted by mini-css-extract-plugin
export default {"row":"SecondScreen_row__zD1Q8","title":"SecondScreen_title__C0ZWr"};